import React from 'react';
import styled from 'styled-components';
import {useOutlet} from 'reconnect.js';
import About from '../../../static/images/about-pinbar.png';

function AboutPinbar(props) {
  const [dimension] = useOutlet('dimension');
  const mobile = dimension.rwd === 'mobile';

  return (
    <Wrapper mobile={mobile}>
      <Container mobile={mobile}>
        <img
          src={About}
          style={{width: '100%', objectFit: 'cover'}}
          alt="about"
        />
      </Container>
      <Container mobile={mobile}>
        <div className="content">
          <h3>關於 PINBAR</h3>
          <p>
            關於 Pinbar 拼圖，是一個家喻戶曉的益智遊戲
            同時也是家庭成員可以一同開心遊樂、創造回憶的物品。
            而PINBAR拼吧，致力於拼圖的製作與印製，我們希望可以把這份乘載回憶的物件，創造出更美好的價值。
            透過客製化拼圖，將屬於您們的回憶、作品，一片一片的組合起來
            將這份感動在拼圖上顯現，也在拼組的當下創造另一段回憶。
          </p>
        </div>
      </Container>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: ${(props) => (props.mobile ? 'column-reverse' : 'row')};
  width: 100%;
`;

const Container = styled.div`
  display: flex;
  width: 100%;
  background-color: var(--primaryColor);

  & > .content {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    background-color: var(--primaryColor);
    padding: 30px;

    & > h3 {
      width: 100%;
      padding-bottom: 25px;
      border-bottom: 2px solid #ffffff;

      text-align: center;
      font-size: 32px;
      color: #ffffff;
    }

    & > p {
      width: 100%;
      padding: 25px;
      text-align: center;
      font-size: 15px;
      color: #ffffff;
      font-weight: 500;
      line-height: 2.47;
    }

    @media screen and (max-width: 550px) {
      padding: 20px;

      & > h3 {
        padding-bottom: 15px;
        font-size: 24px;
      }

      & > p {
        padding-top: 15px;
        font-size: 14px;
        line-height: normal;
      }
    }
  }
`;

export default AboutPinbar;
